import React from 'react';
import { HeaderWrapper } from './Header.style';
import { cms } from 'assets/cms';
import { Link } from 'react-router-dom';
import Navigation from 'components/molecules/navigation/Navigation';
import styled from 'styled-components';
// import AnimationLogo from './AnimationLogo';
import './Style.css';

const ImgWrapper = styled.div`
  img {
    /* height: 40px; */
  }
`;

const ProjImg = styled.img`
  height: 35px;
`;
const EleImg = styled.img`
  height: 30px;
`;
const OzeImg = styled.img`
  height: 40px;
  margin-top: -10px;
`;

const Header = () => (
  <HeaderWrapper>
    {/* <Link to="/"> */}
    <ImgWrapper>
      {/* <img src={cms.logo.proj} /> */}

      {/* <AnimationLogo /> */}
      <div class="frame">
        <div class="container">
          <ul>
            <li class="slide">
              <ProjImg src={cms.logo.proj} />
            </li>
            <li class="slide">
              <EleImg src={cms.logo.ele} />
            </li>
            <li class="slide">
              <OzeImg src={cms.logo.oze} />
            </li>
          </ul>
        </div>
      </div>
    </ImgWrapper>

    {/* </Link> */}
    <Navigation />
  </HeaderWrapper>
);

export default Header;
